// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "3366592cf4ae20017f15" + "/js/" + chunkId + ".js";
};